export default {
  // step 1
  register_demo_request: '/register-demo-request',
  verify_otp_sms: '/verify-otp-sms',

  // step 2
  simulated_scenario: '/simulated-scenario',
  script_preview: '/script-preview',

  // country code picker
  enabled_country_codes: '/enabled-country-codes',

  // admin panel
  admin_login: '/admin/login',
  admin_logout: '/admin/logout',
  admin_me: '/admin/me',
  admin_account_change_password: '/admin/account/change-password',
  admin_scenarios: '/admin/scenarios',
  admin_scenario_prompts: (sid) => `/admin/scenarios/${sid}/prompts`,
  admin_scenario_prompt_lang: (sid, lang) => `/admin/scenarios/${sid}/prompts/${lang}`,
  admin_country_codes: '/admin/country-codes',
  admin_audit: '/admin/audit',
  admin_reload_prompts: '/admin/system/reload-prompts'
}
